<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: rawMenu.user.slug }}"
    :showCloseButton="true"
  >
    <div
      class="text-center my-3"
      slot="heading"
    >
      <h1
        v-if="!submitting && cartItems.length"
        class=" mb-0"
      >
        <span class="font-weight-bold">Your order</span>
      </h1>

    </div>
    <div
      slot="content"
      class="mt-4"
    >
      <div v-if="!submitting && cartItems.length">
        <div>
          <menuItem
            v-for="(item,i) in cartItems"
            :menu="rawMenu"
            :item="item"
            :index="i"
            v-bind:key="'it-' + item.id + i"
            class=" pt-4 pb-3 cursor-pointer d-block animate__animated animate__fadeIn m-itm d-block border-bottom "
            v-bind:id="itemIdPrefix + item.slug"
            v-bind:data-slug="item.slug"
          />
        </div>
        <div
          class="rounded shadow-sm m-3"
          v-if="!submitting"
        >
          <div class=" p-3 bg-light">
            <h2 class="text-center font-weight-bold">Complete order</h2>
            <div v-if="rawMenu.user.enable_pickup_orders || rawMenu.user.require_table_numbers">
              <div
                class="form-group"
                v-if="rawMenu.user.enable_pickup_orders"
              >
                <div
                  role="group"
                  aria-label="Show"
                  class="btn-group btn-group-lg btn-group-block mb-3"
                ><button
                    type="button"
                    class="btn btn-inverse"
                    :class="{
                                            'selected': localCartDeliveryMode==0
                                        }"
                    @click="localCartDeliveryMode=0; updateDeliveryMode(0)"
                  ><i class="fal fa-utensils-alt"></i> Eat-In</button> <button
                    type="button"
                    class="btn btn-inverse"
                    :class="{
                                            'selected': localCartDeliveryMode==1
                                        }"
                    @click="localCartDeliveryMode=1;updateDeliveryMode(1)"
                  ><i class="fal fa-walking"></i> Pickup</button></div>
              </div>
              <div class="mt-2">
                <label for="receipt_email">Name</label>
                <input
                  v-model="localCustomerName"
                  placeholder="Your name"
                  maxlength="128"
                  type="text"
                  class="form-control mb-1"
                  v-bind:class="{ 'is-invalid': customer_name_error }"
                  @change="updateCustomerName(localCustomerName)"
                >
                <small
                  v-if="customer_name_error||errors.customer_name"
                  class="text-danger"
                >
                  Please enter your name
                </small>
              </div>
              <div
                v-if="rawMenu.user.require_table_numbers&&localCartDeliveryMode==0"
                class="animate__animated animate__fadeIn"
              >
                <label v-if="rawMenu.user.qr_placement_type==0">Table number</label> <label v-else>Room number</label>
                <input
                  placeholder="Number"
                  v-model="localTableNumber"
                  type="text"
                  class="form-control ft-3 mb-2"
                  v-bind:class="{ 'is-invalid': table_number_error }"
                  @change="updateTableNumber(localTableNumber)"
                />
                <small
                  v-if="table_number_error"
                  class="text-danger"
                >
                  Please enter your table number
                </small>
              </div>
            </div>
          </div>
          <div
            class="mt-2 p-3"
            v-if="gettingCustomer"
          >
            <img
              src="/storage/images/svg-loaders/three-dots.svg"
              width="20"
              class="img-fluid"
            />
          </div>
          <div
            class="mt-2 p-3"
            v-if="!customer"
          >
            <label for="receipt_email">Paperless receipt email</label>
            <input
              v-model="localReceiptEmail"
              placeholder="Email Address"
              maxlength="128"
              type="email"
              class="form-control mb-1"
              v-bind:class="{ 'is-invalid': receipt_email_error }"
              @change="updateReceiptEmail(localReceiptEmail)"
            >
            <small
              v-if="receipt_email_error||errors.receipt_email"
              class="text-danger"
            >
              Please enter your email address
            </small>

            <div class="mt-2 ">

              <label class="container-label">
                <span class="tiny-text font-weight-normal w-90">Yes. I’d like to get discount codes and deals from {{ rawMenu.user.name }}.</span>
                <input
                  type="checkbox"
                  v-model="email_consent"
                >

              </label>
            </div>
          </div>

          <div
            class="mt-2 p-3"
            v-if="rawMenu.user.allow_special_instructions"
          >
            <label for="special_istructions">Special instructions</label>
            <p
              v-if="rawMenu.user.special_instructions"
              class="text-muted small mb-1"
            >{{ rawMenu.user.special_instructions }}</p>
            <textarea
              v-model="localSpecialInstructions"
              maxlength="250"
              type="text"
              class="form-control ft-3"
              @change="updateSpecialInstructions(localSpecialInstructions)"
            ></textarea>

          </div>

          <div class="p-3 bg-light">
            <hr>
            <label class="mb-0">Rewards</label>
            <hr>
            <div v-if="rawMenu.user.enable_rewards">
              <div v-if="rawMenu.user.point_rewards && rawMenu.user.point_rewards.enabled">
                <div
                  v-if="customer && customer.points>=(rawMenu.user.point_rewards.order_amount_spent*1000) && (orderAmount-(rawMenu.user.point_rewards.order_amount_discounted * 100)) > rawMenu.user.currency.stripe_min_charge_amount"
                  class="d-flex align-item-center point-rewards"
                >
                  <div class="mr-2 icn"><i class="fad fa-star"></i></div>
                  <div>
                    You have enough points for a <span class="font-weight-bold">{{ rawMenu.user.currency.symbol}}{{rawMenu.user.point_rewards.order_amount_discounted }}</span> discount. Discount will be applied at checkout.
                  </div>
                </div>
                <div
                  v-else
                  class="d-flex align-item-center point-rewards"
                >
                  <div class="mr-2 icn"><i class="fad fa-badge-dollar"></i></div>

                  <div>
                    <div class="font-weight-bold">
                      <div v-if="rawMenu.user.point_rewards.label">{{ rawMenu.user.point_rewards.label }}</div>
                      <div v-else>{{rawMenu.user.point_rewards.label }}'s Rewards</div>
                    </div>

                    <div class="small">
                      When you collect {{rawMenu.user.point_rewards.order_amount_spent*1000  }} points, you get a <span class="font-weight-bold">{{ rawMenu.user.currency.symbol}}{{rawMenu.user.point_rewards.order_amount_discounted }}</span> discount on your next order over {{ rawMenu.user.currency.symbol}}{{parseFloat(rawMenu.user.point_rewards.order_amount_discounted) + parseFloat((rawMenu.user.currency.stripe_min_charge_amount/100)+(stripeApplicationFee/100))}}.
                      <div
                        v-if="customer && customer.points"
                        class="customer-points font-weight-bold"
                      >You have earned {{ customer.points  }} points so far. </div>
                      <div class="font-weight-bold">Complete your purchase to earn <span v-if="customer && customer.points">another</span> {{ (orderAmount/100)*1000  }} points.</div>

                    </div>
                  </div>
                </div>

              </div>
              <img
                src="/storage/images/svg-loaders/three-dots.svg"
                width="20"
                class="img-fluid"
                v-if="gettingCustomer"
              />
              <div
                v-if="!customer"
                class="mt-2"
              >
                <div class="tiny-text text-muted mb-1">Login with your phone number to earn points</div>
                <div class="input-group input-group-lg">
                  <div class="input-group-prepend">

                    <select
                      id="country"
                      v-model="localCustomerCountryCode"
                      class="form-control"
                      @change="updateCustomerCountryCode(localCustomerCountryCode)"
                    >
                      <option>
                        Select your country
                      </option>
                      <option
                        v-for="(country,index) in uniqueCountryCodes"
                        v-bind:value="country.calling_code"
                        :key="index"
                      >
                        {{ country.calling_code }}
                      </option>
                    </select>
                  </div>
                  <input
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="number"
                    v-model="localCustomerPhone"
                    @change="updateCustomerPhone(localCustomerPhone)"
                    v-bind:class="{ 'is-invalid': customer_phone_error }"
                  >
                </div>
                <small
                  v-if="customer_phone_error"
                  class="text-danger"
                >
                  Please enter your phone number
                </small>
                <div
                  class="text-danger small my-2"
                  v-if="customerLoginErrorMessage"
                >{{ customerLoginErrorMessage }}</div>
                <div
                  v-if="!customerLoggingIn"
                  class="small font-weight-bold d-flex align-items-center mt-3"
                ><a
                    class="d-flex mr-2"
                    @click="customerLogin()"
                  >Login</a> <button
                    @click="customerSignUp()"
                    class="btn btn-sm btn-primary"
                  >Sign Up</button></div>
                <div v-else> <img
                    src="/storage/images/svg-loaders/three-dots.svg"
                    width="20"
                    class="img-fluid"
                  /></div>
              </div>
            </div>

          </div>
          <div
            v-if="rawMenu.user.enable_tips && tipPercentages && (!skipTipping)"
            class="my-2 p-3"
          >

            <label v-if="rawMenu.user.tipping_text">{{rawMenu.user.tipping_text}}</label><label v-else>Please leave a tip</label>
            <div>
              <div
                v-for="(tip,t) in tipPercentages"
                v-bind:key="'t-' + t"
                class="btn  btn-tip m-1 "
                :class="{
                                            'selected': tip.selected
                                        }"
                @click="selectTip(tip,true)"
              >
                <div
                  class="tiny-text font-weight-normal"
                  :class="{'text-muted':!tip.selected}"
                ><span>{{ rawMenu.user.currency.symbol}}{{Math.round((tip.rate/100) * orderAmount )| centsToDollars}}</span></div>
                <div class="font-weight-bold">{{ tip.rate }}%</div>
              </div>
            </div>
            <div
              class="my-2"
              v-if="rawMenu.user.enable_custom_tips"
            >
              <a
                class="small"
                @click="customTipAmountActive=true"
              >I'd like to tip a different amount</a>
              <input
                v-if="customTipAmountActive"
                placeholder="Amount"
                v-model="customTipAmount"
                type="number"
                class="form-control mb-2"
                @input="addCustomTip()"
              />
            </div>
            <div class="p-3">
              <hr />
              <button
                v-if="rawMenu.user.skip_tipping"
                class="btn btn-inverse btn-block"
                @click="skipTips()"
              >Skip tipping</button>
            </div>

            <div
              class="py-2"
              v-if="!processing"
            >
              <div
                class="text-danger text-center small my-2"
                v-if="checkoutErrorMessage!=''"
              >{{ checkoutErrorMessage }}</div>
              <checkoutButton
                :tipAmount="tipAmount"
                @checkout="checkout"
              ></checkoutButton>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!cartItems.length && !processing"
        class="text-center pb-3 text-muted"
      >
        <i class="fad fa-shopping-bag fa-5x "></i>
        <div class="small"> Your cart is empty</div>

      </div>

      <formLoader
        v-if="appProcessing||submitting"
        class="text-center my-5"
      ></formLoader>

    </div>
  </modal>
</template>

<style lang="scss" scoped>
.btn-group.btn-group-block .btn.selected {
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
}
.btn-tip {
  border-radius: 0.5rem;
  padding: 0.2rem 0.5rem;
  background-color: #fff;
  border-color: var(--user-highlight-color);
  color: var(--user-highlight-color);
  width: 30.6%;

  &.selected {
    background-color: var(--user-highlight-color);
    color: #fff;
  }
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.input-group-prepend {
  select {
    width: 5rem;
    border-right: 0;
    border-radius: 0.5rem 0 0 0.5rem;
    height: auto;
  }
}
.point-rewards {
  font-size: 1rem;
  .icn {
    font-size: 2rem;
    color: var(--user-highlight-color);
  }
  .customer-points {
    color: var(--user-highlight-color);
  }
}
</style>

<script>
import formLoader from "../../components/form/FormLoader";
import pageMixin from "../../mixins/pageMixin";
import cartMixin from "../../mixins/cartMixin";
import modal from "../shared/Modal";
import menuItem from "./Item";
import checkoutButton from "../../components/cart/CheckoutButton";
import accountingMixin from "../../mixins/accountingMixin";
import customerMixin from "../../mixins/customerMixin";
import appData from "../../mixins/appDataApiMixin";
export default {
  mounted() {
    this.getCountries();
    // pre selected tip
    let _self = this;

    _.forEach(_self.tipPercentages, function (tpValue, tKey) {
      if (tpValue.selected) {
        _self.selectTip(tpValue, false);
      }
    });

    if (this.isValidJson(this.rawMenu.user.tip_rates)) {
      let tips = JSON.parse(_.cloneDeep(this.rawMenu.user.tip_rates));
      if (tips.length) {
        this.tipPercentages = tips;

        _.forEach(tips, function (rm, cRM) {
          if (rm.selected) {
            _.forEach(_self.tipPercentages, function (tValue, cKey) {
              if (rm.rate == tValue.rate) {
                _self.selectTip(tValue, false);
              }
            });
          }
        });
      }
    }
    if (localStorage.customerEmail) {
      this.localReceiptEmail = localStorage.customerEmail;
    }
    if (localStorage.customerName) {
      this.localCustomerName = localStorage.customerName;
    }
    if (localStorage.customerPhone) {
      this.localCustomerPhone = localStorage.customerPhone;
    }
    if (localStorage.customerCountryCode) {
      this.localCustomerCountryCode = localStorage.customerCountryCode;
    }
    this.getCustomer();
    this.$gtag.pageview({
      page_title: "Your order | " + this.rawMenu.user.name + " Menu",
    });
  },
  data() {
    return {
      items: [],
      processing: false,
      localTableNumber: "",
      localCartDeliveryMode: 0,
      localSpecialInstructions: "",
      localReceiptEmail: "",
      checkoutErrorMessage: "",
      table_number_error: false,
      receipt_email_error: false,
      submitting: false,
      email_consent: true,
      tipPercentages: [
        { rate: 10, selected: false },
        { rate: 15, selected: false },
        { rate: 18, selected: false },
        { rate: 20, selected: true },
        { rate: 25, selected: false },
      ],
      tipAmount: 0,
      customTipAmount: null,
      customTipAmountActive: false,
      skipTipping: false,
    };
  },
  computed: {
    uniqueCountryCodes: function () {
      let uniq = _.uniqBy(this.countries, (obj) => obj.calling_code);
      return _.sortBy(uniq, "calling_code");
    },
  },
  metaInfo() {
    return {
      title: "Your order |" + this.rawMenu.user.name + " Menu",
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content: "Your order | " + this.rawMenu.user.name + " Menu",
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: "Your order | " + this.rawMenu.user.name + " Menu",
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content: "Your order | " + this.rawMenu.user.name + " Menu",
        },
      ],
    };
  },
  methods: {
    checkout: function () {
      this.checkoutErrorMessage = "";
      this.table_number_error = false;
      this.customer_name_error = false;
      this.receipt_email_error = false;

      this.errors = {};
      if (
        this.rawMenu.user.require_table_numbers == 1 &&
        this.localCartDeliveryMode == 0 &&
        !this.localTableNumber
      ) {
        this.table_number_error = true;
        return false;
      }

      let email = null;
      if (this.customer && this.customer.email) {
        email = this.customer.email;
      } else {
        if (!this.localReceiptEmail) {
          this.receipt_email_error = true;
          return false;
        } else {
          email = this.localReceiptEmail;
        }
      }
      if (!this.localCustomerName) {
        this.customer_name_error = true;
        return false;
      }
      this.table_number_error = false;
      this.receipt_email_error = false;
      this.customer_name_error = false;
      this.processing = true;

      this.submitting = true;

      axios
        .post("/api/customer/checkout", {
          delivery_mode: parseInt(this.localCartDeliveryMode),
          table_number: this.localTableNumber,
          special_instructions: this.localSpecialInstructions,
          receipt_email: email,
          customer_name: this.localCustomerName,
          email_consent: this.email_consent,
          tip_amount: this.tipAmount,
        })
        .then(
          (response) => {
            if (response.data.id) {
              location.href = "/" + this.rawMenu.user.slug + "/checkout";
            } else {
              location.href = "/" + this.rawMenu.user.slug + "/cart";
            }
          },
          (error) => {
            this.processing = false;
            this.submitting = false;
            this.checkoutErrorMessage =
              "Something went wrong, please try again";
            this.errors = error.response.data.errors;
          }
        );
    },
    isValidJson: function (str) {
      if (!str) {
        return false;
      }
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    skipTips: function () {
      this.tipAmount = 0;
      this.skipTipping = true;
    },
    addCustomTip: function () {
      this.tipAmount = 0;
      _.forEach(this.tipPercentages, function (tValue, cKey) {
        tValue.selected = false;
      });
      if (this.customTipAmount > 0) {
        this.tipAmount = Math.round(parseFloat(this.customTipAmount) * 100);
      }
    },
    selectTip: function (tip, update_cart) {
      let _self = this;
      this.tipAmount = 0;

      let centsToDollars = centsToDollars;
      _.forEach(this.tipPercentages, function (tValue, cKey) {
        if (tValue.rate === tip.rate) {
          if (update_cart) {
            tValue.selected = !tValue.selected;
          } else {
            //from cart
            tValue.selected = true;
          }
          if (tValue.selected) {
            _self.tipAmount = Math.round((tip.rate / 100) * _self.orderAmount);
            _self.customTipAmount = null;
          }
        } else {
          tValue.selected = false;
        }
      });

      this.tipPercentages = _.cloneDeep(this.tipPercentages);
      if (update_cart && this.tipAmount) {
        this.updateSelectedTipRate(tip.rate);
      }
    },
  },
  watch: {
    cart(newValue, oldValue) {
      this.localTableNumber = newValue.table_number;
      this.localCartDeliveryMode = newValue.delivery_mode;
      this.localSpecialInstructions = newValue.special_instructions;
      if (newValue.receipt_email) {
        this.localReceiptEmail = newValue.receipt_email;
      }
      if (newValue.customer_name) {
        this.localCustomerName = newValue.customer_name;
      }
      if (newValue.customer_phone) {
        this.localCustomerPhone = newValue.customer_phone;
      }
      if (newValue.customer_country_code) {
        this.localCustomerCountryCode = newValue.customer_country_code;
      }
      if (newValue.customer_id) {
        this.getCustomer();
      }

      if (this.tipPercentages.length) {
        let _self = this;
        _.forEach(this.tipPercentages, function (tValue, cKey) {
          if (tValue.rate == newValue.tip_rate) {
            _self.selectTip(tValue, false);
            return;
          }
        });
      }
    },
  },
  components: {
    formLoader,
    modal,
    menuItem,
    checkoutButton,
  },
  mixins: [pageMixin, cartMixin, accountingMixin, customerMixin, appData],
};
</script>
